import {
  CREATE_CSV_PENDING,
  CREATE_CSV_FAIL,
  CREATE_CSV_SUCCESS,
  GET_CSV_HEADERS_PENDING,
  GET_CSV_HEADERS_FAIL,
  GET_CSV_HEADERS_SUCCESS,
} from '../actions/csvActions';


const initialState = {
  csv: {
    loading: false,
    loaded: true,
    file: null,
    sequence: null,
    headers: [],
  },
};


const csvReducer = (state = initialState.csv, action) => {
  switch (action.type) {
    case CREATE_CSV_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_CSV_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_CSV_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_CSV_HEADERS_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_CSV_HEADERS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_CSV_HEADERS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        headers: action.payload,
      };
    default:
      return state;
  }
};

export default csvReducer;
